import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, Briefcase } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { isAuthenticated, isAdmin, user } = useAuth();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/marketplace', label: 'Marketplace' },
    { path: '/ai-auto-poster', label: 'AI Auto-Poster' },
    { path: '/ai-lab', label: 'AI Lab' },
  ];

  if (isAuthenticated && !isAdmin) {
    navLinks.push({ path: '/dashboard', label: 'My Dashboard' });
  }

  if (isAdmin) {
    navLinks.push({ path: '/admin', label: 'Admin' });
  }

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 w-full bg-black/60 backdrop-blur-xl z-50 border-b border-white/10" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group" data-testid="nav-logo">
            <div className="bg-gradient-to-br from-orange-500 to-red-600 p-2 rounded-lg transform transition-transform group-hover:scale-110 shadow-lg shadow-orange-500/30">
              <Briefcase className="w-6 h-6 text-white" />
            </div>
            <span className="text-lg sm:text-xl font-bold bg-gradient-to-r from-orange-400 to-red-500 bg-clip-text text-transparent">
              Kari Future Now Creations
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                  isActive(link.path)
                    ? 'bg-orange-500/15 text-orange-300 border border-orange-500/30'
                    : 'text-white/70 hover:text-white hover:bg-white/5'
                }`}
              >
                {link.label}
              </Link>
            ))}
            {isAuthenticated ? (
              <div className="ml-4 flex items-center space-x-2">
                <span className="text-sm text-white/60">Hi, {user?.name}</span>
              </div>
            ) : (
              <Link to="/login">
                <Button className="ml-4 bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white shadow-lg shadow-orange-500/30" data-testid="nav-login-btn">
                  Admin Login
                </Button>
              </Link>
            )}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg text-white/80 hover:bg-white/10 transition-colors"
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive(link.path)
                    ? 'bg-orange-500/15 text-orange-300'
                    : 'text-white/70 hover:bg-white/5 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-2">
              {isAuthenticated ? (
                <div className="px-4 py-2 text-sm text-white/60">
                  Hi, {user?.name}
                </div>
              ) : (
                <Link to="/login" onClick={() => setIsOpen(false)}>
                  <Button className="w-full bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white">
                    Admin Login
                  </Button>
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
